"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _InfiniteTabs = _interopRequireDefault(require("../../Common/InfiniteTabs"));
var _Tab = _interopRequireDefault(require("../../../Tab"));
var _TicketCard = _interopRequireDefault(require("../TicketCard"));
var _EmptyTicketsList = _interopRequireDefault(require("../EmptyTicketsList"));
var _TicketCardSkeleton = _interopRequireDefault(require("../TicketCardSkeleton"));
var _excluded = ["itemCount", "minimumBatchSize", "onLoadRequest", "tickets", "threshold", "hasNextPage", "isNextPageLoading", "isLoadingList", "planReasons"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ticketCardPropType = _TicketCard["default"].propTypes;
var clientPropType = ticketCardPropType.client,
  ticketPropType = ticketCardPropType.ticket;
var infiniteTabsDefaultProps = _InfiniteTabs["default"].defaultProps,
  infiniteTabsPropTypes = _InfiniteTabs["default"].propTypes;
var itemCountDefaultProp = infiniteTabsDefaultProps.itemCount,
  minimumBatchSizeDefaultProp = infiniteTabsDefaultProps.minimumBatchSize,
  onLoadRequestDefaultProp = infiniteTabsDefaultProps.onLoadRequest,
  thresholdDefaultProp = infiniteTabsDefaultProps.threshold,
  valueDefaultProp = infiniteTabsDefaultProps.value;
var itemCountPropType = infiniteTabsPropTypes.itemCount,
  minimumBatchSizePropType = infiniteTabsPropTypes.minimumBatchSize,
  onLoadRequestPropType = infiniteTabsPropTypes.onLoadRequest,
  thresholdPropType = infiniteTabsPropTypes.threshold,
  valuePropType = infiniteTabsPropTypes.value;
var TICKET_HEIGHT = 160;
var TicketList = /*#__PURE__*/function (_React$PureComponent) {
  function TicketList(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TicketList);
    _this = _callSuper(this, TicketList, [props]);
    _this.state = {
      activeId: props.value
    };
    _this.handleSelect = _this.handleSelect.bind(_this);
    _this.isItemLoaded = _this.isItemLoaded.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(TicketList, _React$PureComponent);
  return (0, _createClass2["default"])(TicketList, [{
    key: "handleSelect",
    value: function handleSelect(activeId) {
      var onSelect = this.props.onSelect;
      this.setState({
        activeId: activeId
      }, function () {
        return onSelect(activeId);
      });
    }
  }, {
    key: "isItemLoaded",
    value: function isItemLoaded(index) {
      var tickets = this.props.tickets;
      return (0, _has2["default"])(tickets, "".concat(index, ".ticket.id"));
    }
  }, {
    key: "renderSkeletons",
    value: function renderSkeletons() {
      return new Array(5).fill(null).map(function (el) {
        return /*#__PURE__*/_react["default"].createElement(StyledTicketCardSkeleton, null);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        itemCount = _this$props.itemCount,
        minimumBatchSize = _this$props.minimumBatchSize,
        onLoadRequest = _this$props.onLoadRequest,
        tickets = _this$props.tickets,
        threshold = _this$props.threshold,
        hasNextPage = _this$props.hasNextPage,
        isNextPageLoading = _this$props.isNextPageLoading,
        isLoadingList = _this$props.isLoadingList,
        planReasons = _this$props.planReasons,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var activeId = this.state.activeId;
      return /*#__PURE__*/_react["default"].createElement(StyledTicketList, props, (0, _isArray2["default"])(tickets) && !tickets.length && !isLoadingList && /*#__PURE__*/_react["default"].createElement(_EmptyTicketsList["default"], null), isLoadingList && this.renderSkeletons(), /*#__PURE__*/_react["default"].createElement(_InfiniteTabs["default"], {
        hasNextPage: hasNextPage,
        isNextPageLoading: isNextPageLoading,
        isItemLoaded: this.isItemLoaded,
        itemCount: itemCount,
        itemData: tickets,
        itemKey: TicketList.getItemKey,
        itemSize: TICKET_HEIGHT,
        minimumBatchSize: minimumBatchSize,
        onLoadRequest: onLoadRequest,
        onSelect: this.handleSelect,
        threshold: threshold,
        value: activeId
      }, function (_ref) {
        var data = _ref.data,
          index = _ref.index,
          style = _ref.style;
        if (!data || !data[index]) {
          return null;
        }
        var _data$index = data[index],
          client = _data$index.client,
          ticket = _data$index.ticket;
        var planReason = (planReasons || []).find(function (reason) {
          return reason.id === ticket.plannedReasonId;
        });
        var id = ticket.id,
          read = ticket.read,
          priority = ticket.priority;
        var disabled = !id || !client;
        return /*#__PURE__*/_react["default"].createElement(StyledTab, {
          read: read,
          style: style,
          value: id,
          priority: priority,
          disabled: disabled
        }, /*#__PURE__*/_react["default"].createElement(_TicketCard["default"], {
          planReason: planReason,
          client: client,
          ticket: ticket
        }));
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref2, _ref3) {
      var value = _ref2.value;
      var activeId = _ref3.activeId;
      if (value !== activeId) {
        return {
          activeId: value
        };
      }
      return null;
    }
  }, {
    key: "getItemKey",
    value: function getItemKey(index, data) {
      if (!data || !(0, _has2["default"])(data, "".concat(index, ".ticket.id"))) {
        return null;
      }
      return data[index].ticket.id;
    }
  }]);
}(_react["default"].PureComponent);
TicketList.propTypes = {
  className: _propTypes["default"].string,
  itemCount: itemCountPropType,
  minimumBatchSize: minimumBatchSizePropType,
  onLoadRequest: onLoadRequestPropType,
  onSelect: _propTypes["default"].func,
  threshold: thresholdPropType,
  tickets: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    client: _propTypes["default"].shape(clientPropType).isRequired,
    ticket: _propTypes["default"].shape(_objectSpread(_objectSpread({}, ticketPropType), {}, {
      id: _propTypes["default"].string.isRequired
    })).isRequired
  }).isRequired).isRequired,
  value: valuePropType,
  hasNextPage: _propTypes["default"].bool.isRequired,
  isNextPageLoading: _propTypes["default"].bool.isRequired,
  isLoadingList: _propTypes["default"].bool.isRequired,
  planReasons: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].string.isRequired
  }).isRequired)
};
TicketList.defaultProps = {
  className: '',
  itemCount: itemCountDefaultProp,
  minimumBatchSize: minimumBatchSizeDefaultProp,
  onLoadRequest: onLoadRequestDefaultProp,
  onSelect: Function.prototype,
  threshold: thresholdDefaultProp,
  value: valueDefaultProp
};
var StyledTicketList = _styledComponents["default"].div.withConfig({
  displayName: "TicketList__StyledTicketList",
  componentId: "sc-167ywsa-0"
})(["height:100%;width:100%;"]);
var StyledTab = (0, _styledComponents["default"])(_Tab["default"]).withConfig({
  displayName: "TicketList__StyledTab",
  componentId: "sc-167ywsa-1"
})(["border:none;background-color:#f5f3f2;", " ", " @keyframes pulsing{from{background-color:#fefad0;}to{background-color:#f5fed0;}}"], function (_ref4) {
  var read = _ref4.read,
    priority = _ref4.priority;
  return !read && "\n      background-color: white;\n      animation: ".concat(priority ? 'pulsing 6s infinite ease-in-out' : 'none', ";\n  ");
}, function (_ref5) {
  var selected = _ref5.selected;
  return selected && "\n    background-color: #fff;\n  ";
});
var StyledTicketCardSkeleton = (0, _styledComponents["default"])(_TicketCardSkeleton["default"]).withConfig({
  displayName: "TicketList__StyledTicketCardSkeleton",
  componentId: "sc-167ywsa-2"
})(["margin-bottom:12px;"]);
var _default = exports["default"] = TicketList;